import {
  Alert,
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  BUTTON_STYLES,
  FORM_STYLES,
  MODAL_STYLES,
  TEXT_FIELD_STYLES,
} from "../../styles/componentStyles";
import { useFormik } from "formik";
import api from "../../axiosInstance";
import { toast } from "react-toastify";
import collegeSchema from "../Validations/BannerValidation";

function CollegeModal({ States, open, onClose, collegesEdit, onSuccess }) {
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [universities, setUniversities] = useState([]);

  // Fetch dropdown data once
  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const universitiesRes = await api.get("/getAllUniversities");
        setUniversities(universitiesRes.data.data);
      } catch (err) {
        const message =
          err.response?.data?.message ||
          err.message ||
          "Something went wrong while fetching dropdown data";
        setError(message);
        console.error("Dropdown fetch error:", err);
      }
    };

    fetchDropdownData();
  }, []);
  // Remove the Dubulicate categories
  const uniqueByCategory = categories.filter(
    (value, index, self) =>
      index === self.findIndex((obj) => obj.category === value.category)
  );

  //  Form vlaidation using useFormik hook
  const formik = useFormik({
    initialValues: {
      name: collegesEdit?.name || "",
      universityId: collegesEdit?.universityId || "",
      address: collegesEdit?.address || "",
      active: collegesEdit?.active ?? "true",
    },

    validationSchema: collegeSchema.collegeSchema,
    enableReinitialize: true,

    onSubmit: async (values, { resetForm, setSubmitting }) => {
      console.log(collegesEdit?.id);
      try {
        setSubmitting(true);
        let response;
        // If it's Edit data it will call Update api
        if (collegesEdit?.id) {
          response = await api.put(`/api/colleges/${collegesEdit?.id}`, values);
          console.log(values);
        }

        // Else it's Add data it will call Add api
        else {
          console.log(values);

          response = await api.post("/api/colleges", values);
        }
        // Show success toast
        toast.success(
          `College ${collegesEdit?.id ? "updated" : "added"} successfully!`,
          {
            position: "top-right",
            autoClose: 2000,
          }
        );
        onSuccess(response.data.data);
        resetForm();
        onClose();
      } catch (error) {
        toast.error("Failed to submit. Please try again.", {
          autoClose: 3000,
        });
        console.error("API Error:", error);
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <>
      {/* Loading State */}
      {isLoading && (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      )}
      <Modal open={open} onClose={onClose} disableScrollLock>
        <Box
          sx={{ ...MODAL_STYLES.standard, width: { xs: 340, md: 500 } }}
          component="form"
          onSubmit={formik.handleSubmit}
        >
          <Typography
            variant="h5"
            component="h2"
            sx={{ mb: 3, fontWeight: 600 }}
          >
            {collegesEdit && Object.keys(collegesEdit).length > 0
              ? "Update College"
              : "Add College"}
          </Typography>
          <Box sx={FORM_STYLES.container}>
            <TextField
              label="College Name"
              name="name"
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
              {...TEXT_FIELD_STYLES.standard}
              required
            />
            <FormControl
              fullWidth
              error={
                formik.touched.universityId &&
                Boolean(formik.errors.universityId)
              }
            >
              <InputLabel>University</InputLabel>
              <Select
                name="universityId"
                value={formik.values.universityId}
                onChange={formik.handleChange}
                label="University"
                onBlur={formik.handleBlur}
                error={
                  formik.touched.universityId &&
                  Boolean(formik.errors.universityId)
                }
              >
                {universities.map((u) => (
                  <MenuItem key={u.id} value={u.id}>
                    {u.id} {"-"} {u.name}
                  </MenuItem>
                ))}
              </Select>
              {formik.touched.universityId && formik.errors.universityId && (
                <FormHelperText sx={{ color: "red" }}>
                  {formik.errors.universityId}
                </FormHelperText>
              )}
            </FormControl>
            <TextField
              label="Address"
              name="address"
              value={formik.values.address}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.address && Boolean(formik.errors.address)}
              helperText={formik.touched.address && formik.errors.address}
              {...TEXT_FIELD_STYLES.standard}
            />

            <FormControl
              fullWidth
              error={formik.touched.active && Boolean(formik.errors.active)}
              sx={{ mt: 2 }}
            >
              <InputLabel id="active-label">Active</InputLabel>
              <Select
                labelId="active-label"
                id="active"
                name="active"
                value={formik.values.active}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label="Active"
              >
                <MenuItem value="true">Yes</MenuItem>
                <MenuItem value="false">No</MenuItem>
              </Select>
              {formik.touched.active && formik.errors.active && (
                <FormHelperText>{formik.errors.active}</FormHelperText>
              )}
            </FormControl>
            <Box
              sx={FORM_STYLES.actions}
              style={{
                display: "flex",
                marginTop: "20px",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              <Button onClick={onClose} {...BUTTON_STYLES.secondary}>
                Cancel
              </Button>
              <Button
                type="submit"
                disabled={formik.isSubmitting}
                {...BUTTON_STYLES.primary}
              >
                {formik.isSubmitting ? "Processing..." : "Save"}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default CollegeModal;
